import httpClient from '../httpClient';

const post = async (data) => {
  return await httpClient.post(
    `/organizations/`,
    data,
    {
      headers: {
        'Content-Type': `multipart/form-data;`,
      },
    },
  );
};

const getAll = async () => {
  return await httpClient.get(
    `/organizations/?page[size]=1000`,
  );
};

const get = async (id) => {
  return await httpClient.get(
    `/organizations/${id}`,
  );
};

const put = async (id, data) => {
  return await httpClient.put(
    `/organizations/${id}/`,
    data,
    {
      headers: {
        'Content-Type': `multipart/form-data;`,
      },
    },
  );
};

const remove = async (id) => {
  return await httpClient.delete(
    `/organizations/${id}`,
  );
};

const filter = async (query) => {
  return await httpClient.get(
    `/organizations${query}`,
  );
};

export { post, getAll, get, put, remove, filter };
